import React, { Component } from 'react';
import {FaRegUser , FaDollarSign , FaHatCowboy , FaLink } from "react-icons/fa";

export class DashboardTwo extends Component {
  render() {
    return (
        <div className="container subdashboardmargindiv">
            <div className="row">
                <div className="col-6 dashboard-two-headline"><span>Statistics</span></div>
                <div className="col-6 content-end dashboard-two-headline-right mg-top-right"><span>Updated 3 month ago</span></div>

                <div className="col-12 dashboard-two-secondpart">
                    <div className="row">
                    <div className="col-3 content-center">
                    <div className="row">
                        <div className="col-4 itemiconsec">
                            <span className="dashboardimgbg FaSalesBg">
                                <FaHatCowboy className="dashboard-two-icon FaIconSales" />
                            </span>
                        </div>
                        <div className="col-8">
                            <span className="dashboard-two-heading-first">230K</span> <br />
                            <span className="dashboard-two-headline-right">Sales</span>
                        </div>
                    </div>
                </div>
                <div className="col-3 content-center">
                    <div className="row">
                        <div className="col-4 itemiconsec">
                            <span className="dashboardimgbg FaCoustomerBg">
                                <FaRegUser className="dashboard-two-icon FaiconCoustomer" />
                            </span>
                        </div>
                        <div className="col-8">
                            <span className="dashboard-two-heading-first">8,549K</span> <br />
                            <span className="dashboard-two-headline-right">Customers</span>
                        </div>
                    </div>
                </div>
                <div className="col-3 content-center">
                    <div className="row">
                        <div className="col-4 itemiconsec">
                            <span className="dashboardimgbg FaProductBg">
                                <FaLink className="dashboard-two-icon FaIconProduct" />
                            </span>
                        </div>
                        <div className="col-8">
                            <span className="dashboard-two-heading-first">1,423K</span> <br />
                            <span className="dashboard-two-headline-right">Products</span>
                        </div>
                    </div>
                </div>
                <div className="col-3 content-center">
                    <div className="row">
                        <div className="col-4 itemiconsec">
                            <span className="dashboardimgbg FaDollerBg">
                                <FaDollarSign className="dashboard-two-icon FaIconDoller" />
                            </span>
                        </div>
                        <div className="col-8">
                            <span className="dashboard-two-heading-first">$9745</span> <br />
                            <span className="dashboard-two-headline-right">Revanue</span>
                        </div>
                    </div>
                </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
  }
}

export default DashboardTwo ;